import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectReportTemplate(
    request: Boundaries["editProjectReportTemplate"]["request"],
  ): void;
}

function useEditProjectReportTemplate(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectReportTemplateRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectReportTemplateRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectReportTemplateRequestFailure(planzone),
    ),
    editProjectReportTemplate: core.editProjectReportTemplate,
  };
}

export { useEditProjectReportTemplate };
